<template>
  <!-- eslint-disable -->
  <div style="text-align:left;">
    <template v-if="isMobile">
       <GoogleAnalyticsMobile :prestadorId="prestadorId" />
    </template>
    <template v-else>
      <div class="column-left">
        <SideNav />
      </div>
      <div>
        <div class="column-right">
          <TopNavClean />
          <div class="main-container">
            <div v-if="loaded" class="professionals-container">
              <!-- Header Section -->
              <div class="page-header">
                <div class="header-content">
                  <div class="title-section">
                    <div class="page-icon" :style="iconStyle">
                      <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <path fill-rule="evenodd"
                          d="M12.037 21.998a10.313 10.313 0 0 1-7.168-3.049 9.888 9.888 0 0 1-2.868-7.118 9.947 9.947 0 0 1 3.064-6.949A10.37 10.37 0 0 1 12.212 2h.176a9.935 9.935 0 0 1 6.614 2.564L16.457 6.88a6.187 6.187 0 0 0-4.131-1.566 6.9 6.9 0 0 0-4.794 1.913 6.618 6.618 0 0 0-2.045 4.657 6.608 6.608 0 0 0 1.882 4.723 6.891 6.891 0 0 0 4.725 2.07h.143c1.41.072 2.8-.354 3.917-1.2a5.77 5.77 0 0 0 2.172-3.41l.043-.117H12.22v-3.41h9.678c.075.617.109 1.238.1 1.859-.099 5.741-4.017 9.6-9.746 9.6l-.215-.002Z"
                          clip-rule="evenodd" />
                      </svg>
                    </div>
                    <div>
                      <h1 class="page-title">Dashboard Google Analytics</h1>
                      <p class="page-subtitle">Métricas y estadísticas de agenda {{ prestador.nombre }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Componente dinámico o mensaje alternativo -->
              <component :is="currentDashboard" v-if="hasDashboard" />
              <div v-else class="no-dashboard-message">
                <div class="empty-state">
                  <div v-if="!prestadorId && (prestador.id === 1 || prestador.id === 23)">
                    <h3>Seleccione un Dashboard</h3>
                    <p>Elija el prestador para visualizar sus métricas:</p>
                    <div class="dashboard-selector" style="display: flex; flex-wrap: wrap; gap: 10px; justify-content: center; margin-top: 20px;">
                      <button v-for="(loader, pid) in dashboards" :key="pid" class="btn-dashboard"
                        @click="selectDashboard(pid)"
                        :style="{
                          padding: '10px 20px',
                          border: '1px solid #e2e8f0',
                          borderRadius: '8px',
                          background: 'white',
                          cursor: 'pointer',
                          fontWeight: '600',
                          color: '#475569'
                        }">
                        {{ getDashboardName(pid) }}
                      </button>
                    </div>
                  </div>
                  <div v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
                      stroke="#64748b" stroke-width="1.5">
                      <path d="M3 3h18v18H3zM21 9H3m18 6H3m12-6V3m-6 6V3m-6 6v12m6-6v6m6-6v6" />
                    </svg>
                    <h3>Característica en Desarrollo</h3>
                    <p>Nos encontramos en desarrollo de reportería potenciada con Google Analytics para conocer el recorrido
                      de los clientes.</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Loading State -->
            <div v-else class="loading-container">
              <div class="loading-content">
                <Loader :height="100" :width="100" />
                <h3>Cargando dashboard...</h3>
                <p>Por favor espere mientras cargamos la información</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNavClean from './TopNavClean.vue';
import GoogleAnalyticsMobile from './GoogleAnalyticsMobile.vue';

export default {
  name: 'GoogleAnalytics',
  props: {
    prestadorId: {
      type: Number,
      required: false,
      default: null
    }
  },
  components: {
    SideNav,
    Loader,
    TopNavClean,
    GoogleAnalyticsMobile
  },
  data() {
    return {
      loaded: false,
      hasDashboard: false,
      currentDashboard: null,
      isMobile: false,
      dashboards: {
        3: () => import('@/components/dashboardsGoogle/Dashboard_3.vue'),
        5: () => import('@/components/dashboardsGoogle/Dashboard_5.vue'),
        9: () => import('@/components/dashboardsGoogle/Dashboard_9.vue'),
        13: () => import('@/components/dashboardsGoogle/Dashboard_13.vue'),
        14: () => import('@/components/dashboardsGoogle/Dashboard_14.vue'),
        15: () => import('@/components/dashboardsGoogle/Dashboard_15.vue'),
        18: () => import('@/components/dashboardsGoogle/Dashboard_18.vue'),
      }
    }
  },
  computed: {
    ...mapGetters(['prestador']),
    iconStyle() {
      return {
        backgroundImage: `linear-gradient(139deg, ${this.prestador?.admin?.assets?.colors?.primary || '#3b82f6'} 0%, ${this.prestador?.admin?.assets?.colors?.secondary || '#6366f1'} 100%)`
      }
    }
  },
  async mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    if (!this.isMobile) {
        await this.loadDashboard();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    async loadDashboard(forcedId = null) {
      if (this.isMobile) return; // Mobile component handles its own loading
      this.loaded = false;
      try {
        const pid = forcedId || this.prestadorId || Number(this.prestador?.id);

        if (pid && this.dashboards[pid]) {
          const component = await this.dashboards[pid]();
          this.currentDashboard = component.default;
          this.hasDashboard = true;
        } else {
          this.hasDashboard = false;
        }
      } catch (error) {
        console.error('Error cargando el dashboard:', error);
        this.hasDashboard = false;
      } finally {
        this.loaded = true;
      }
    },
    checkForDashboard() {
      this.loadDashboard();
    },
    getDashboardName(pid) {
      const names = {
        3: 'Bionet',
        5: 'Alemana',
        9: 'Integramedica',
        13: 'Laboratorio Blanco',
        14: 'UC Christus',
        15: 'Davila',
        18: 'SportsMD'
      };
      return names[pid] || `Prestador ${pid}`;
    },
    selectDashboard(pid) {
      // Navegar a la ruta con el ID seleccionado
      this.$router.push({ name: 'GoogleAnalyticsById', params: { id: pid } });
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(newId) {
        if (!this.isMobile) this.loadDashboard(newId); 
      }
    },
    isMobile(val) {
        if (!val) this.loadDashboard();
    }
  },
}
</script>


<style scoped>
/* Tus estilos existentes */
.column-right {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.main-container {
  padding: 20px;
}

.professionals-container {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.page-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.loading-content {
  text-align: center;
  max-width: 400px;
}

.loading-content h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin: 1rem 0 0.5rem;
}

.loading-content p {
  color: #64748b;
  margin: 0;
  line-height: 1.6;
}

/* Estilos para el mensaje de no dashboard */
.no-dashboard-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}

.empty-state {
  text-align: center;
  max-width: 400px;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.empty-state h3 {
  color: #1e293b;
  margin: 1rem 0 0.5rem;
}

.empty-state p {
  color: #64748b;
  margin-bottom: 1.5rem;
}

.btn-refresh {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-refresh:hover {
  background-color: #2563eb;
}

@media (max-width: 1200px) {
  .column-right {
    padding-left: 0px;
  }
}

@media (max-width: 768px) {
  .page-header {
    padding: 1.5rem;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .page-icon {
    width: 48px;
    height: 48px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }
}
</style>